import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'setAnchor' })
export class SetAnchorPipe implements PipeTransform {
    transform(value: string, bu: string): any {
        if (!(value && bu)) {
            return;
        }
        return bu.substring(0, 3) + value.substring(value.length - 4, value.length);
    }
}
